export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore7.2e44079a.jpg";